import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-sand py-20" aria-labelledby="faq-title" data-id="element-62" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-63" data-mp="1cf9mmeotibj6">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-forest-900 md:text-4xl" data-id="element-64" data-mp="1ccdooqcyzmuq">
          Frequently asked questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-65" data-mp="254gsxzuik5ez">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-lg border border-earth-200 bg-white" data-id="element-66" data-mp="1v5hkoidnubsi" data-mpi={index}>
                <h3 className="font-sans" data-id="element-67" data-mp="op5rywtlxm4b">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-forest-900 transition-colors duration-150 ease-out hover:bg-forest-50 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-gold-400/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-68" data-mp="omt1fv9sa3fn">
                    <span data-id="element-69" data-mp="1fn2hk3j0zkuh">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-earth-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-70" data-mp="11x8unqr2zane" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-71" data-mp="rx853n2mbyar">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-72" data-mp="wyfdnocl51ih">
                      <p className="border-t border-earth-100 px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-73" data-mp="2poq0aw4hwhc9">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}